import { render, staticRenderFns } from "./dropdown-select-check.vue?vue&type=template&id=0cb28c24&scoped=true&"
import script from "./dropdown-select-check.ts?vue&type=script&lang=ts&"
export * from "./dropdown-select-check.ts?vue&type=script&lang=ts&"
import style0 from "./dropdown-select-check.scss?vue&type=style&index=0&id=0cb28c24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb28c24",
  null
  
)

export default component.exports